import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import getBrandIdv from "@faire/web-api--source/api/help-center/brand-verification/get";

import {
  InstantAnswerRequiredData,
  InstantAnswerRequiredDataFn,
} from "../types";

const NO_BRAND_IDV_TOKEN: InstantAnswerRequiredData = {
  field: "brandIdvToken",
  data: undefined,
};

export const BrandIdvTokenDataFn: InstantAnswerRequiredDataFn = () => {
  const brandToken = getBrand()?.token;
  if (!brandToken) {
    return Promise.resolve(NO_BRAND_IDV_TOKEN);
  }

  return getBrandIdv()
    .then<InstantAnswerRequiredData>((response) => ({
      field: "brandIdvToken",
      data: response.brand_idv_request?.token,
    }))
    .catch(() => NO_BRAND_IDV_TOKEN) as Promise<InstantAnswerRequiredData>;
};
